// C:\IntegraNube_WebStore\src\pages\SeguimientoPedido.js
'use strict';

import React, { useState } from 'react';

import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Snackbar,
  Stack,
  TextField,
  Typography
} from '@mui/material';

import {
  LocalShippingOutlined as ShippingIcon,
  Search as SearchIcon
} from '@mui/icons-material';

export default function SeguimientoPedido() {
  const [numero, setNumero] = useState('');
  const [email, setEmail] = useState('');

  const [snack, setSnack] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  const handleSearch = (event) => {
    event.preventDefault();

    if (!numero.trim() || !email.trim()) {
      setSnack({
        open: true,
        message: 'Ingresa el número de pedido y el email utilizado en la compra.',
        severity: 'warning'
      });
      return;
    }

    setSnack({
      open: true,
      message:
        'La pantalla está lista. Falta conectar el endpoint de consulta de pedidos.',
      severity: 'info'
    });
  };

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100%' }}>
      <Container maxWidth="sm" sx={{ py: { xs: 4, md: 7 } }}>
        <Stack spacing={2.5}>
          <Box textAlign="center">
            <ShippingIcon
              sx={{
                fontSize: 60,
                color: 'primary.main',
                mb: 1
              }}
            />

            <Typography variant="h4" fontWeight={950}>
              Sigue tu pedido
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mt: 1 }}
            >
              Consulta el estado de tu compra con los datos de tu pedido.
            </Typography>
          </Box>

          <Paper
            component="form"
            onSubmit={handleSearch}
            variant="outlined"
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 3,
              bgcolor: '#fff'
            }}
          >
            <Stack spacing={1.5}>
              <TextField
                fullWidth
                label="Número de pedido"
                value={numero}
                onChange={(e) => setNumero(e.target.value)}
              />

              <TextField
                fullWidth
                type="email"
                label="Email de la compra"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <Alert severity="info">
                La consulta real se activará cuando definamos el endpoint de seguimiento.
              </Alert>

              <Button
                type="submit"
                variant="contained"
                size="large"
                startIcon={<SearchIcon />}
                sx={{
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 900,
                  boxShadow: 'none'
                }}
              >
                Consultar pedido
              </Button>
            </Stack>
          </Paper>
        </Stack>
      </Container>

      <Snackbar
        open={snack.open}
        autoHideDuration={4200}
        onClose={() =>
          setSnack((prev) => ({ ...prev, open: false }))
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity={snack.severity}
          variant="filled"
          onClose={() =>
            setSnack((prev) => ({ ...prev, open: false }))
          }
          sx={{ width: '100%' }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
